<template>
  <div class="custom-margin-full-page" style="max-height: 2000px">
    <v-row>
      <v-col cols="3">
        <v-row>
          <v-col cols="12" class="text-right">
            {{ dictation.label != null ? dictation.label : dictation.title }}          </v-col>
          <v-col cols="12" class="text-right mt-4">
            پاسخ درست : {{ correctAnswerNumber }}
          </v-col>
          <v-col cols="12">
            <v-btn
                v-if="dictation.file && dictation.file !== ''"
                elevation="0" @click="goToFile(dictation.file)" style="letter-spacing: normal">
              <v-icon>mdi-paperclip</v-icon>
              فایل راهنما
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="9">
        <div v-for="(child,index) in dictation.children" :key="child.id + 'children'">
          <v-row v-if="dictationChildrenSelectedIndex === index" class="audio-container align-center py-2">
            <v-col cols="12" class="text-right mt-4">
              سوال : {{ tries + 1 }} /{{ dictation.children.length }}
            </v-col>
            <v-col cols="12">
              {{ dictation.description }}
            </v-col>
            <v-col
                v-if="child.file && child.file !== ''"
                cols="12" class="audio-player">
              <audio
                  :src="child.file" controls></audio>
            </v-col>

            <v-col cols="12"></v-col>
            <v-col cols="12"
                   style="direction: ltr!important;">
              <v-row>
                <v-col cols="2" v-for="(option,index) in answersObject.options" :key="index + 'answer'">
                  <img :src="option.cover" v-if="answersObject.status === null" class="answer-image">
                  <img :src="option.cover" v-else-if="answersObject.status === true" class="answer-image-correct">
                  <img :src="option.cover" v-else class="answer-image-incorrect">
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12"></v-col>
            <v-row class="custom-option-margin">
              <v-col
                  :cols="getColSize(child,optionIndex)"
                  v-for="(option, optionIndex) in child.options_array"
                  :key="index + 'option' + optionIndex"
              >
                <img :src="option.cover" class="option-image" @click="buildAnswer(option)"/>
              </v-col>
            </v-row>
            <!--            <v-row class="custom-option-margin">-->
            <!--              <v-col cols="4" class="text-center" v-if="examStatus === null">-->
            <!--                <v-btn block v-if="canSeeClearButton && submitButtonCondition" width="200" color="warning"-->
            <!--                       class="submit-button mx-1" @click="clear()">-->
            <!--                  پاک کن-->
            <!--                </v-btn>-->
            <!--              </v-col>-->
            <!--              <v-col cols="8">-->
            <!--                <v-btn block v-if="canSeeApproveButton && submitButtonCondition" width="200" color="success"-->
            <!--                       class="submit-button mx-1"-->
            <!--                       @click="checkDictation()">تایید-->
            <!--                </v-btn>-->
            <!--              </v-col>-->
            <!--              <v-col cols="12" class="text-center">-->
            <!--                <p v-if="showTimeoutCounter"> {{ countdown }} </p>-->
            <!--              </v-col>-->
            <!--            </v-row>-->
          </v-row>
        </div>
      </v-col>
      <v-col cols="3"></v-col>
      <v-col cols="9" class="tex-center">
        <v-btn class="mx-4" :color="nextButtonCondition ? 'success' : ''" :class="nextButtonCondition ? 'active' : 'disabled'" @click="goNext()">
          <span class="icon"><v-icon >mdi-arrow-right</v-icon></span>
        </v-btn>
        <v-btn class="mx-4"  @click="checkDictation()" :color="answersObject.options.length && submitButtonCondition ? 'success' : ''">
        <span class="icon"><v-icon large >mdi-check</v-icon></span>
        </v-btn>
        <v-btn class="mx-4"  @click="clear()" :color="answersObject.options.length && submitButtonCondition ? 'warning' : ''">
          <span class="icon"><v-icon >mdi-eraser</v-icon></span>
        </v-btn>
      </v-col>
    </v-row>
    <v-row>

    </v-row>
    <v-dialog width="80%" v-model="showExamDetailsDialog">
      <v-card>
        <v-card-actions>
          <v-btn @click="closeExamDetailDialog()">
            <v-icon color="error">
              mdi-close
            </v-icon>
          </v-btn>
        </v-card-actions>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              امتیاز شما
              {{ score }}
            </v-col>
            <v-col cols="12">
              در صورت نیاز برای انجام دوباره، {{ tryAgainTime }} دقیقه دیگر اقدام کنید.
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>

export default {
  name: "DictationItemDesktop",
  props: ['item', 'dictation', 'answers', 'onlineClass'],
  data() {
    return {
      correctAnswerNumber: 0,
      examStatus: null,
      score: 0,
      showExamDetailsDialog: false,
      submitButtonCondition: true,
      tryAgainTime: null,
      lastAnswerStatus: null,
      loading: true,
      previousAnswers: [],
      options: [],
      alphabets: [],
      timeout: 3000,
      countdown: 5,
      showTimeoutCounter: false,
      dictationChildrenSelectedIndex: 0,
      answersObject:
          {
            status: null,
            options: []
          },
      currentAnswerLine: 0,
      answerIdString: "",
      tries: 0,
      nextButtonCondition: false,
    }
  },
  computed: {
    canSeeClearButton() {
      return !!this.answersObject.options.length;
    },
    canSeeApproveButton() {
      return !!this.answersObject.options.length;
    }
  },
  methods: {
    getColSize(child, optionIndex) {
      const totalOptions = child.options_array.length;
      // Custom logic for handling number of columns
      if (totalOptions === 5) {
        // 3 in first row, 2 in second row
        return optionIndex < 3 ? 4 : 6;
      } else if (totalOptions === 6) {
        // 3 in first row, 3 in second row
        return 4;
      } else if (totalOptions === 7) {
        // 4 in first row, 3 in second row
        return optionIndex < 4 ? 3 : 4;
      } else {
        // Default case, 4 per row
        return 3;
      }
    },
    goToFile(url) {
      window.open(url, "_blank");
    },
    closeExamDetailDialog() {
      this.showExamDetailsDialog = false
      window.close();
    },
    goToNextQuestion() {
      window.location.reload();
    },
    getAlphabets() {
      this.options.forEach((option) => {
        window.axios.post('/course/dictation/alphabet/search', {
          ids: option
        }).then((res) => {
          this.alphabets.push(res.data.data)
        })
      })
    },
    notifyLessonProgressChanged() {
      localStorage.setItem('dorakk:dictation-progress-updated', JSON.stringify({
        itemId: this.$route.params.itemId,
        classId: this.$route.params.classId,
        courseId: this.item && this.item.course ? this.item.course.id : null,
        dictationId: this.dictation.id,
        updatedAt: Date.now()
      }))
    },
    getDictationStatus() {
      window.axios.get('/student/courses/lessons/dictation/get-dictation-status/' + this.dictation.id).then((res) => {
        this.tries = res.data.data.tries
        this.round = res.data.data.round
        this.correctAnswerNumber = res.data.data.correct_answer_count
        this.dictationChildrenSelectedIndex = res.data.data.dictation_selected_index
        this.answersObject = {
          status: null,
          options: []
        }
        this.tryAgainTime = res.data.data.try_again_time
        this.submitButtonCondition = true
        this.showTimeoutCounter = false
        if (res.data.data.show_ended_dialog) {
          this.examStatus = 'ended'
          this.score = (this.correctAnswerNumber / this.dictation.children.length) * 100
          this.showExamDetailsDialog = true
        }
        this.nextButtonCondition = false
      })
    },
    buildAnswer(option) {
      if (!this.submitButtonCondition) {
        return;
      }
      this.answersObject.options.push(option)
      this.answerIdString += (this.answerIdString ? ',' : '') + option.id;
    },
    checkDictation() {
      if (!this.submitButtonCondition) {
        return;
      }
      if (!this.answersObject.options.length) {
        return;
      }
      this.submitButtonCondition = false
      let status = null
      status = this.answerIdString === this.dictation.children[this.dictationChildrenSelectedIndex].correct_answer;
      this.answersObject.status = status
      window.axios.post('/student/courses/lessons/dictation/answer', {
        item_dictation_id: this.dictation.id,
        item_dictation_children_id: this.dictation.children[this.dictationChildrenSelectedIndex].id,
        status: status ? 'correct' : 'incorrect',
        answer: this.answerIdString,
      }).then(() => {
        this.notifyLessonProgressChanged()
        this.answerIdString = "";
        if (this.tries + 1 < this.dictation.children.length) {
          this.showTimeoutCounter = true;
        }
        this.nextButtonCondition = true
        // this.countdown = this.timeout / 1000;
        // let self = this;
        // let interval = setInterval(() => {
        //   if (self.countdown > 0) {
        //     self.countdown--;
        //   } else {
        //     clearInterval(interval);
        //     self.getDictationStatus();
        //   }
        // }, 1000);
      }).catch(() => {
        this.answerIdString = "";
      });
    },
    goNext() {
      if (this.nextButtonCondition) {
        this.getDictationStatus()
      }
    },
    clear() {
      if (!this.submitButtonCondition) {
        return;
      }
      this.answersObject.options.pop()
      const lastCommaIndex = this.answerIdString.lastIndexOf(',');
      if (lastCommaIndex !== -1) {
        this.answerIdString = this.answerIdString.slice(0, lastCommaIndex);
      } else {
        this.answerIdString = '';
      }
    }
    ,
    sendDictation() {

    }
  },
  mounted() {
    this.dictation.children.forEach((childDictation) => {
      this.options.push(childDictation.options.split(',').map(Number))
    })
    this.getAlphabets()
    this.getDictationStatus()
  }
}
</script>

<style scoped>

:root {
  --nav-h: 64px; /* bar height (without safe-area) */
  --nav-bg: rgba(255, 255, 255, 0.9);
  --nav-fg: #111;
  --nav-fg-muted: #666;
  --nav-accent: #0ea5e9;
  --nav-shadow: 0 -6px 20px rgba(0, 0, 0, 0.08);
}

/* Prevent content from being hidden behind the fixed bar */
body {
  padding-bottom: calc(var(--nav-h) + env(safe-area-inset-bottom, 0px));
}

/* Sticky bottom navbar (fixed to viewport) */
.bottom-nav {
  position: absolute;
  top: 30% !important;
  right: 50% !important;
  gap: 4px;

  background: var(--nav-bg);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-top: 1px solid rgba(0, 0, 0, 0.06);
  box-shadow: var(--nav-shadow);

  /* comfortable tap area + iOS notch support */
  padding: 8px 10px calc(8px + env(safe-area-inset-bottom, 0px));
}

/* Items */
.bottom-nav a {
  flex: 1 1 0;
  min-width: 0;
  text-decoration: none;
  color: var(--nav-fg-muted);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border-radius: 12px;
  font-size: 12px;
  line-height: 1;
  padding: 8px 6px;
  -webkit-tap-highlight-color: transparent;
}

.bottom-nav a .icon {
  font-size: 20px;
}

.bottom-nav a.active,
.bottom-nav a:focus-visible,
.bottom-nav a:hover {
  color: var(--nav-fg);
  background: rgba(0, 0, 0, 0.04);
  outline: none;
}

/* Active indicator */
.bottom-nav a.active {
  position: relative;
}

.bottom-nav a.active::after {
  content: "";
  position: absolute;
  top: -1px;
  left: 20%;
  right: 20%;
  height: 3px;
  border-radius: 3px;
  background: var(--nav-accent);
}

/* Optional: hide labels on very small screens */
@media (max-width: 360px) {
  .bottom-nav .label {
    display: none;
  }

  .bottom-nav a .icon {
    font-size: 22px;
  }
}

/* Optional: turn into a top bar on large screens */
@media (min-width: 900px) {
  .bottom-nav {
    max-width: 760px;
    margin: 0 auto;
    border-radius: 16px 16px 0 0;
  }
}


.answer-image {
  border-radius: 10px;
  width: 200px;
  height: 200px;
  object-fit: cover;
}

.answer-image-correct {
  border-radius: 10px;
  border-color: green;
  border-style: solid;
  width: 200px;
  height: 200px;
  object-fit: cover;
}

.answer-image-incorrect {
  border-radius: 10px;
  border-color: red;
  border-style: solid;
  width: 200px;
  height: 200px;
  object-fit: cover;
}

.option-image {
  border-radius: 10px;
  width: 85%;
  height: 150px;
  object-fit: fill;
  cursor: pointer;
  transition: transform 0.2s, filter 0.2s; /* Animation */
}

.option-image:hover {
  transform: scale(1.1); /* The image will scale up to 110% of its original size */
  filter: grayscale(80%);
}

.submit-button {
  letter-spacing: normal;
}

.file-show-container {
  height: 500px !important;
}

.image-lesson {
  height: 100%;
  width: 100%;
  object-fit: cover;
}

.custom-margin-full-page {
  margin: 5vh 10vw 0 10vw;
}

.back-link-icon {
  color: #413e3e !important;
}

.back-link-icon:hover {
  color: orangered !important;
}

.audio-container {
  display: flex;
  align-items: center; /* Vertically aligns children */
  background-color: #f9f9f9; /* Light background for readability */
  border-radius: 8px; /* Rounded corners for the container */
  padding: 10px; /* Uniform padding */
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1); /* Subtle shadow for depth */
}

.audio-index {
  color: #1ab69d; /* Green color for the index, consistent with theme */
  font-size: 1.2rem; /* Slightly larger font for emphasis */
}

.audio-player audio {
  width: 100%; /* Make the audio player take full width */
  border-radius: 8px;
  border: none; /* Removes any default borders */
  outline: none; /* Removes focus border on play */
}

.custom-option-margin {
  margin-left: 15vw;
  margin-right: 15vw;
}
</style>
